import axios, { AxiosPromise } from 'axios';
import { IZalozeniLeiInput } from 'types/leiTypes';

export interface IZalozeniLeiResp {
    varsym: string;
    id?: number;
}

const zalozeniLeiApi = (zalozeniData: IZalozeniLeiInput): AxiosPromise<IZalozeniLeiResp> => {
    return axios({
        method: 'POST',
        url: 'LEI/Registrace',
        data: zalozeniData
    });
};
export default zalozeniLeiApi;
